import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaClock, FaEye, FaArrowLeft, FaTag } from 'react-icons/fa';
import API from '../api/axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const BlogDetail = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  useEffect(() => { API.get(`/blog/slug/${slug}`).then(r => setBlog(r.data)).catch(console.error); }, [slug]);

  if (!blog) return (<><Navbar /><div style={{ paddingTop: '120px', textAlign: 'center', color: 'var(--text-muted)' }}>Loading...</div></>);

  return (
    <>
      <Navbar />
      <div style={{ paddingTop: '100px', minHeight: '100vh', paddingBottom: '60px' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <Link to="/blog" style={{ color: 'var(--primary)', display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '20px' }}><FaArrowLeft /> Back to Blog</Link>
          <span style={{ color: 'var(--primary)', fontSize: '0.85rem', fontWeight: '600' }}>{blog.category}</span>
          <h1 style={{ fontSize: '2.2rem', marginTop: '5px', marginBottom: '15px' }}>{blog.title}</h1>
          <div style={{ display: 'flex', gap: '20px', color: 'var(--text-muted)', fontSize: '0.85rem', marginBottom: '30px' }}>
            <span><FaClock /> {new Date(blog.createdAt).toLocaleDateString()}</span>
            <span><FaEye /> {blog.views} views</span>
            <span>By {blog.author}</span>
          </div>
          <div style={{ background: 'var(--bg-card)', borderRadius: '20px', padding: '40px', border: '1px solid var(--border)', lineHeight: '1.9', color: 'var(--text-secondary)' }}
            dangerouslySetInnerHTML={{ __html: blog.content }} />
          {blog.tags?.length > 0 && (
            <div style={{ display: 'flex', gap: '8px', marginTop: '20px', flexWrap: 'wrap' }}>
              <FaTag style={{ color: 'var(--text-muted)' }} />
              {blog.tags.map((tag, i) => <span key={i} style={{ padding: '4px 12px', background: 'rgba(108,99,255,0.15)', borderRadius: '20px', fontSize: '0.8rem', color: 'var(--primary)' }}>{tag}</span>)}
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogDetail;
